<template>
  <div class="row">
    <div class="col-12 order-first order-lg-last col-lg-4">
      <listing-item
        :listing="listing"
        format="card"
        :link="false"
        :grid="false"
        variant="display"
      >
        <div slot="footer">
          <div class="pt-2">
            <hr>
            <div class="d-flex align-items-center">
              <toggle-button
                v-model="listing.notify_marketing"
              >
              </toggle-button>
              <small class="d-inline-block ml-3">
                {{ listing.notify_marketing ? 'Marketing is notified of updates to price and status.' : 'Marketing is not notified of updates to price and status.' }}
              </small>
            </div>
          </div>
        </div>
      </listing-item>
    </div>

    <div class="col-12 order-last order-lg-first col-lg-8">
      <header class="mb-3 sr-only">
        <h1 class="h3">
          {{ listing.street_address }}, {{ listing.city }}, {{ listing.state }} {{ listing.zip }}
        </h1>
      </header>

      <form
        class="card mb-3"
        method="post"
        action=""
      >
        <div class="card-body">
          <header class="mb-3">
            <h3 class="h4">
              <i class="far fa-fw fa-globe mr-1"></i>
              Single-Property Websites
            </h3>
            <hr>
          </header>
          <p>
            Every Redwood listing gets two single-property websites: one that's
            branded and one that is unbranded, suitable for promoting in the MLS
            and in other aggregated listing marketing platforms.
          </p>

          <div class="form-group">
            <label>Unbranded Website</label>
            <div class="media">
              <div class="media-body">
                <div class="form-control readonly">
                  <a :href="listing.links.unbranded" target="_blank">
                    {{ listing.links.unbranded }}
                  </a>
                </div>
              </div>
              <div class="media-right">
                <share-button
                  btn-class="btn btn-white ml-2"
                  icon="clipboard"
                  :url="listing.links.unbranded"
                >
                  Copy
                </share-button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Branded Website</label>
            <div class="media">
              <div class="media-body">
                <div class="form-control readonly">
                  <a :href="listing.links.branded" target="_blank">
                    {{ listing.links.branded }}
                  </a>
                </div>
              </div>
              <div class="media-right">
                <share-button
                  btn-class="btn btn-white ml-2"
                  icon="clipboard"
                  :url="listing.links.branded"
                >
                  Copy
                </share-button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>

            </label>
          </div>
        </div>
      </form>

      <div class="card">
        <div class="card-body">
          <header class="mb-3">
            <h3 class="h4">
              <i class="fa fa-fw fa-camera mr-1"></i>
              All Photos
            </h3>
            <hr>
          </header>
          <p>These photos were loaded from the MLS.</p>
          <b-carousel
            controls
            indicators
          >
            <b-carousel-slide
              v-for="(media, i) in images"
              :key="media.id"
              style="background-color:#111;"
            >
              <template v-slot:img>
                <img
                  class="d-block"
                  :style="imgStyle"
                  :src="media.url_full"
                  :alt="''"
                >
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </div>

      <!--
      <div class="media mb-5">
        <div
          class="media-left"
        >
          <toggle-button v-model="cropped"></toggle-button>
        </div>
        <div
          class="media-body ml-3"
        >
          {{ cropped ? 'Cropped' : 'Not Cropped' }}
        </div>
      </div>
      -->
    </div>
  </div>
</template>

<script>
import ListingItem from '@/components/ListingItem'
import { notifyMarketing, stopNotifyingMarketing } from '@/api'
import { filter } from 'lodash'
import { ToggleButton } from 'vue-js-toggle-button'
import ShareButton from '@/components/ShareButton'

export default {
  components: {
    ListingItem,
    ToggleButton,
    ShareButton
  },
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    showMarketingSubscribe: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listing: this.value,
      cropped: false
    }
  },
  computed: {
    images () {
      return filter(this.listing.media, (media) => {
        return media.type === 'jpeg'
      })
    },
    imgStyle () {
      return this.cropped ? 'height: 60vh; width:auto; margin:-3.8% auto' : 'height: 60vh; width:auto; margin: 0 auto;"'
    }
  },
  watch: {
    'listing.notify_marketing' (value) {
      value ? notifyMarketing(this.listing.id) : stopNotifyingMarketing(this.listing.id)
    }
  },
  mounted () {

  }
}
</script>